import React, { useState } from 'react';

const AdminScenarioUploader = () => {
  const [formData, setFormData] = useState({
    description: '',
    difficulty: 1,
    examples: [''],
    prompt: '',
    summary: '',
    employeeAge: '',
    employeeName: '',
    filters: [],
    jobTitle: '',
    tags: [],
    title: '',
    voiceSsmlGender: 'MALE',
    groups: [''],
    scenarioContext: ['employee', 'supervisor'],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleExampleChange = (index, value) => {
    const updated = [...formData.examples];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, examples: updated }));
  };

  const removeExampleField = (index) => {
    if (formData.examples.length > 1) {
      const updated = [...formData.examples];
      updated.splice(index, 1);
      setFormData((prev) => ({ ...prev, examples: updated }));
    }
  };
  
  const addExampleField = () => {
    setFormData((prev) => ({ ...prev, examples: [...prev.examples, ''] }));
  };

  const toggleFilter = (filter) => {
    const updated = formData.filters.includes(filter)
      ? formData.filters.filter(f => f !== filter)
      : [...formData.filters, filter];
    setFormData((prev) => ({ ...prev, filters: updated }));
  };

  const toggleTag = (tag) => {
    const updated = formData.tags.includes(tag)
      ? formData.tags.filter(t => t !== tag)
      : [...formData.tags, tag];
    setFormData((prev) => ({ ...prev, tags: updated }));
  };

  const handleGroupChange = (index, value) => {
    const updated = [...formData.groups];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, groups: updated }));
  };
  
  const addGroupField = () => {
    setFormData((prev) => ({ ...prev, groups: [...prev.groups, ''] }));
  };
  
  const removeGroupField = (index) => {
    if (formData.groups.length > 1) {
      const updated = [...formData.groups];
      updated.splice(index, 1);
      setFormData((prev) => ({ ...prev, groups: updated }));
    }
  };
  
  const handleScenarioContextChange = (index, value) => {
    const updated = [...formData.scenarioContext];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, scenarioContext: updated }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const scenario = {
      content: [{
        description: formData.description,
        difficulty: Number(formData.difficulty),
        examples: formData.examples,
        prompt: formData.prompt,
        summary: formData.summary,
      }],
      employeeAge: formData.employeeAge,
      employeeName: formData.employeeName,
      filters: formData.filters,
      jobTitle: formData.jobTitle,
      tags: formData.tags,
      title: formData.title,
      voiceLanguageCode: "en-US",
      voiceSsmlGender: formData.voiceSsmlGender,
      groups: formData.groups.filter(g => g.trim() !== ''),
      scenarioContext: formData.scenarioContext.every(x => x.trim())
        ? formData.scenarioContext
        : ["employee", "supervisor"]
    };

    console.log("🔍 Form submission preview:", scenario);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/admin-upload`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(scenario),
      });

      if (res.ok) {
        alert('Scenario uploaded successfully!');
      } else {
        console.error('Upload failed:', await res.text());
        alert('Failed to upload scenario.');
      }
    } catch (err) {
      console.error('Error uploading:', err);
      alert('Upload error occurred.');
    }
  };

  const filterOptions = ['featured', 'new', 'most popular'];
  const tagOptions = [
    'performance & quality issues', 'communication challenges', 'collaboration & team dynamics',
    'motivation & engagement', 'adaptability & change resistance',
    'behavior & professionalism', 'boundaries', 'new hire integration'
  ];

  return (
    <form onSubmit={handleSubmit} className="p-6 max-w-3xl mx-auto space-y-4 bg-white shadow rounded">
        <h2 className="text-2xl font-bold">Upload New Scenario</h2>

        <input type="text" name="title" value={formData.title} onChange={handleChange} placeholder="Scenario Title" className="w-full border p-2" />
        <input type="text" name="employeeName" value={formData.employeeName} onChange={handleChange} placeholder="Employee Name" className="w-full border p-2" />
        <input type="text" name="employeeAge" value={formData.employeeAge} onChange={handleChange} placeholder="Employee Age" className="w-full border p-2" />
        <input type="text" name="jobTitle" value={formData.jobTitle} onChange={handleChange} placeholder="Job Title" className="w-full border p-2" />
        <textarea name="summary" value={formData.summary} onChange={handleChange} placeholder="Summary" className="w-full border p-2" rows={2} />
        <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Description" className="w-full border p-2" rows={4} />
      
        <div>
            <label>Difficulty:</label>
            <select name="difficulty" value={formData.difficulty} onChange={handleChange} className="border ml-2">
            {[1, 3, 5].map(level => <option key={level} value={level}>{level}</option>)}
            </select>
        </div>

        <div>
            <label className="block font-medium mb-1">Examples:</label>
            {formData.examples.map((ex, i) => (
                <div key={i} className="flex items-center mb-2">
                <input
                    value={ex}
                    onChange={(e) => handleExampleChange(i, e.target.value)}
                    className="w-full border p-1"
                    placeholder={`Example ${i + 1}`}
                />
                {formData.examples.length > 1 && (
                    <button
                    type="button"
                    onClick={() => removeExampleField(i)}
                    className="ml-2 text-red-600 text-sm hover:underline"
                    >
                    🗑️
                    </button>
                )}
                </div>
            ))}
            <button
                type="button"
                onClick={addExampleField}
                className="text-blue-600 mt-2 text-sm hover:underline"
            >
                + Add Example
            </button>
        </div>

      <textarea name="prompt" value={formData.prompt} onChange={handleChange} placeholder="Prompt" className="w-full border p-2" rows={4} />

      <div>
        <label className="block font-medium mb-1">Groups:</label>
        {formData.groups.map((group, i) => (
          <div key={i} className="flex items-center mb-2">
            <input
              value={group}
              onChange={(e) => handleGroupChange(i, e.target.value)}
              className="w-full border p-1"
              placeholder={`Group ${i + 1}`}
            />
            {formData.groups.length > 1 && (
              <button
                type="button"
                onClick={() => removeGroupField(i)}
                className="ml-2 text-red-600 text-sm hover:underline"
              >
                🗑️
              </button>
            )}
          </div>
        ))}
        <button
          type="button"
          onClick={addGroupField}
          className="text-blue-600 mt-2 text-sm hover:underline"
        >
          + Add Group
        </button>
      </div>

      <div className="mt-4">
        <label className="block font-medium mb-1">Scenario Context (Who is speaking and who they are talking to):</label>
        <div className="flex gap-4">
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1">AI Role (who the assistant is)</label>
            <input
              value={formData.scenarioContext[0]}
              onChange={(e) => handleScenarioContextChange(0, e.target.value)}
              placeholder="e.g., coach, father, teammate"
              className="w-full border p-1"
            />
          </div>
          <div className="w-1/2">
            <label className="block text-sm font-medium mb-1">User Role (who the user is)</label>
            <input
              value={formData.scenarioContext[1]}
              onChange={(e) => handleScenarioContextChange(1, e.target.value)}
              placeholder="e.g., student athlete, child, employee"
              className="w-full border p-1"
            />
          </div>
        </div>
      </div>

      <div>
        <label>Filters:</label>
        <div className="flex gap-2 flex-wrap">
          {filterOptions.map(f => (
            <label key={f} className="flex items-center">
              <input type="checkbox" checked={formData.filters.includes(f)} onChange={() => toggleFilter(f)} />
              <span className="ml-1">{f}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <label>Tags:</label>
        <div className="flex gap-2 flex-wrap">
          {tagOptions.map(tag => (
            <label key={tag} className="flex items-center">
              <input type="checkbox" checked={formData.tags.includes(tag)} onChange={() => toggleTag(tag)} />
              <span className="ml-1">{tag}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <label>Voice Gender:</label>
        <select name="voiceSsmlGender" value={formData.voiceSsmlGender} onChange={handleChange} className="border ml-2">
          <option value="MALE">MALE</option>
          <option value="FEMALE">FEMALE</option>
        </select>
      </div>

      <button type="submit" className="mt-4 px-6 py-2 bg-green-600 text-white rounded">Submit Scenario</button>
    </form>
  );
};

export default AdminScenarioUploader;
